import { render, staticRenderFns } from "./BaseTooltip.vue?vue&type=template&id=32eb5bf3&scoped=true&"
import script from "./BaseTooltip.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BaseTooltip.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BaseTooltip.vue?vue&type=style&index=0&id=32eb5bf3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eb5bf3",
  null
  
)

export default component.exports